// Van gallery images
import vanFront from "assets/images/cars/van_front.webp";
import vanFrontInterior from "assets/images/cars/van_front_interior.webp";
import vanBackInterior from "assets/images/cars/van_back_interior.webp";
import vanBack from "assets/images/cars/van_back.webp";

// Showcase (stock) images
import vanStock from "assets/images/cars/van_stock_image.webp";
import rav4Stock from "assets/images/cars/rav4_stock_image.webp";

// Van rentals are arranged directly with the owners over email
export const CONTACT_EMAIL = "croceanfrontrentals@gmail.com";

// The rental fleet. Each vehicle renders as an alternating image/spec showcase.
export const vehicles = [
  {
    eyebrow: "2027 \u00b7 Van",
    name: "Hyundai H1 Staria GL",
    image: vanStock,
    imageAlt: "Brand-new 2027 Hyundai Staria van available to rent",
    description:
      "Travel in comfort and style. Our brand-new 2027 Staria is the easiest way to move your whole group around the coast without sacrificing any comfort. Enjoy the scenery through the extra-large polarized windows and settle into the roomy interior, loaded with the latest tech.",
    specs: [
      { icon: "groups", label: "Seats up to 9 passengers" },
      { icon: "auto_mode", label: "Automatic transmission" },
      { icon: "smartphone", label: "Apple CarPlay & Android Auto" },
      { icon: "luggage", label: "Moderate luggage space" },
    ],
  },
  {
    eyebrow: "2017 \u00b7 Compact SUV",
    name: "Toyota RAV4",
    image: rav4Stock,
    imageAlt: "Silver 2017 Toyota RAV4 compact SUV available to rent",
    description:
      "Need something nimble for a smaller group? Our 2017 Toyota RAV4 is a comfortable, fuel-efficient SUV \u2014 perfect for day trips, grocery runs and exploring the coast.",
    specs: [
      { icon: "groups", label: "Seats up to 5 passengers" },
      { icon: "auto_mode", label: "Automatic transmission" },
      { icon: "smartphone", label: "Apple CarPlay & Android Auto" },
      { icon: "luggage", label: "Large luggage space" },
    ],
  },
];

// "Good to know" rental terms shown before the reserve CTA
export const rentalTerms = [
  {
    icon: "airport_shuttle",
    title: "Your free airport transfers",
    body: "Free transportation includes one shuttle from the airport to the property and one return trip back \u2014 free for groups of up to 9. Beyond that it\u2019s just $10 per additional person. If your group arrives on separate flights and needs more than one pickup, only the first trip is free; any extra shuttles are at your expense, but we\u2019re glad to help arrange them.",
  },
  {
    icon: "credit_card",
    title: "Credit card & security hold",
    body: "A credit card is required upon arrival to rent our vehicles. We place a temporary $1,500 hold to cover the insurance deductible. Your rental already includes full-coverage insurance, but \u2014 as with every policy in Costa Rica \u2014 it still carries a deductible, so a hold like this is standard practice here. Every rental company requires it; many just don\u2019t advertise it online and only ask when you arrive to pick up the cars. One $1,500 hold covers a single vehicle or both \u2014 we\u2019ll never ask for an additional deposit \u2014 and it\u2019s released after the vehicles are returned.",
  },
];

// How the free two-way airport transfer works, step by step
export const transferSteps = [
  {
    icon: "directions_car",
    title: "Rent directly with us",
    text: "Book the van \u2014 or any of our vehicles \u2014 straight through us. No third-party markups, no booking fees.",
  },
  {
    icon: "flight_land",
    title: "We pick you up",
    text: "Land at the airport and we\u2019ll shuttle you and your group to the property, completely free.",
  },
  {
    icon: "vpn_key",
    title: "Your cars are waiting",
    text: "Arrive to find your rental vehicles ready and waiting at the house \u2014 keys in hand.",
  },
  {
    icon: "flight_takeoff",
    title: "Free ride back",
    text: "When your stay wraps up, we handle your return trip to the airport too. Two-way, always free.",
  },
];

// Photo gallery of the van
export const vanGallery = [
  { src: vanFront, alt: "Front exterior of the brand-new 2027 Hyundai Staria van" },
  {
    src: vanFrontInterior,
    alt: "Staria front cabin with a large touchscreen, Apple CarPlay and Android Auto",
  },
  { src: vanBackInterior, alt: "Spacious rear seating inside the 9-passenger Staria van" },
  { src: vanBack, alt: "Rear view of the 2027 Hyundai Staria van" },
];
